import { motion } from "framer-motion";
import { FC, MouseEventHandler } from "react";
import { BsExclamationDiamond } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import { NavLink } from "react-router-dom";

interface Props {
  loading?: boolean;
  errored?: boolean;
  url: string;
  forced?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const NavigationLink: FC<Props> = (props) => {
  return (
    <NavLink to={props.url} onClick={props.onClick}>
      <motion.li exit={{
        opacity: 0,
        x: 100
      }} initial={{
        opacity: 0,
        x: -100
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        type: "tween"
      }}
                 className="navigation__link">
        {props.children}
        <div className="flex gap-2 mr-2">
          {props.loading && (
            <CgSpinner className="text-xl animate-spin" />
          )}
          {props.errored && (
            <BsExclamationDiamond className="text-xl text-red-600 animate-pulse" />
          )}
          {(props.forced && !props.loading) && (
            <BsExclamationDiamond className="text-xl text-orange-500 animate-pulse" />
          )}
        </div>
      </motion.li>
    </NavLink>
  );
};

export default NavigationLink;